// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1G4Us","title":"ClientInsurance_title__3HU_A","itemText":"ClientInsurance_itemText__2HlKH"};